import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Configura el Ambiente',
    desc: 'Aplicas los cambios de luz y sonido en casa siguiendo la guía.'
  }, {
    num: '2',
    title: 'Sincroniza el Reloj',
    desc: 'Ajustas las siestas según las ventanas de sueño biológicas de tu bebé.'
  }, {
    num: '3',
    title: 'Ejecutas la Pausa',
    desc: 'Sigues el protocolo de intervención táctica durante 3 noches consecutivas.'
  }];
  return <section className="py-24 px-4 bg-cream-50 text-navy-900" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-navy-950 mb-4" data-id="element-123">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg text-navy-700 font-body" data-id="element-124">
            Un proceso claro y estructurado para recuperar tus noches.
          </p>
        </motion.div>

        <div className="relative" data-id="element-125">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-amber-200 -translate-x-1/2" data-id="element-126"></div>

          <div className="space-y-12 md:space-y-24 relative" data-id="element-127">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-center ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-128">
                <div className={`md:w-1/2 flex justify-center md:justify-${index % 2 !== 0 ? 'start' : 'end'} md:px-12 mb-6 md:mb-0`} data-id="element-129">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-amber-100 border-4 border-white shadow-lg flex items-center justify-center relative z-10" data-id="element-130">
                    <span className="text-3xl md:text-4xl font-display font-bold text-amber-600" data-id="element-131">
                      {step.num}
                    </span>
                  </div>
                </div>

                <div className={`md:w-1/2 text-center md:text-left md:px-12 ${index % 2 !== 0 ? 'md:text-right' : ''}`} data-id="element-132">
                  <h3 className="text-2xl font-display font-bold text-navy-900 mb-3" data-id="element-133">
                    {step.title}
                  </h3>
                  <p className="text-navy-700 font-body text-lg leading-relaxed" data-id="element-134">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}